import React, { useState } from 'react';
import { UserIcon, TagIcon, RulerIcon, CalendarIcon } from 'lucide-react';
export function UserProfileSelector({
  userProfile,
  setUserProfile
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const genderOptions = ['Female', 'Male', 'Non-binary', 'Prefer not to say'];
  const styleOptions = ['Classic', 'Casual', 'Formal', 'Gothic', 'Bohemian', 'Sporty', 'Minimalist', 'Vintage', 'Streetwear'];
  const bodyTypeOptions = ['Rectangle', 'Apple', 'Pear', 'Hourglass', 'Athletic', 'Petite', 'Tall'];
  const ageRanges = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
  const handleChange = (field, value) => {
    setUserProfile({
      ...userProfile,
      [field]: value
    });
  };
  // Avatar selection based on profile
  const getAvatarImage = () => {
    if (!userProfile.gender) {
      return 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80';
    }
    // Different avatar images based on gender
    if (userProfile.gender === 'Female') {
      return 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80';
    } else if (userProfile.gender === 'Male') {
      return 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80';
    } else {
      return 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80';
    }
  };
  return <div className="bg-white rounded-xl shadow-md p-4 h-full" data-id="element-181">
      <div className="flex items-center justify-between mb-3" data-id="element-182">
        <div className="flex items-center space-x-2" data-id="element-183">
          <div className="relative" data-id="element-184">
            <img src={getAvatarImage()} alt="User avatar" className="h-8 w-8 rounded-full object-cover border-2 border-indigo-600" data-id="element-185" />
            <UserIcon className="h-4 w-4 text-white absolute -bottom-1 -right-1 bg-indigo-600 p-0.5 rounded-full" data-id="element-186" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-187">
            Your Style Profile
          </h2>
        </div>
        <button onClick={() => setIsExpanded(!isExpanded)} className="text-xs sm:text-sm text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-188">
          {isExpanded ? 'Collapse' : 'Expand'} Profile
        </button>
      </div>
      {!isExpanded ? <div className="flex flex-wrap gap-2" data-id="element-189">
          {userProfile.gender && <span className="px-2 py-1 bg-indigo-100 text-indigo-800 rounded-full text-xs sm:text-sm flex items-center" data-id="element-190">
              <UserIcon className="h-3 w-3 mr-1" data-id="element-191" />
              {userProfile.gender}
            </span>}
          {userProfile.style && <span className="px-2 py-1 bg-indigo-100 text-indigo-800 rounded-full text-xs sm:text-sm flex items-center" data-id="element-192">
              <TagIcon className="h-3 w-3 mr-1" data-id="element-193" />
              {userProfile.style}
            </span>}
          {userProfile.bodyType && <span className="px-2 py-1 bg-indigo-100 text-indigo-800 rounded-full text-xs sm:text-sm flex items-center" data-id="element-194">
              <RulerIcon className="h-3 w-3 mr-1" data-id="element-195" />
              {userProfile.bodyType}
            </span>}
          {userProfile.ageRange && <span className="px-2 py-1 bg-indigo-100 text-indigo-800 rounded-full text-xs sm:text-sm flex items-center" data-id="element-196">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-197" />
              {userProfile.ageRange}
            </span>}
          {!userProfile.gender && !userProfile.style && !userProfile.bodyType && !userProfile.ageRange && <span className="text-gray-500 text-xs sm:text-sm" data-id="element-198">
                Click "Expand Profile" to set your preferences
              </span>}
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-199">
          <div data-id="element-200">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 flex items-center" data-id="element-201">
              <UserIcon className="h-3 w-3 mr-1 text-indigo-600" data-id="element-202" />
              Gender
            </label>
            <div className="space-y-1" data-id="element-203">
              {genderOptions.map(option => <div key={option} className="flex items-center" data-id="element-204">
                  <input id={`gender-${option}`} name="gender" type="radio" checked={userProfile.gender === option} onChange={() => handleChange('gender', option)} className="h-3 w-3 text-indigo-600 focus:ring-indigo-500 border-gray-300" data-id="element-205" />
                  <label htmlFor={`gender-${option}`} className="ml-2 text-xs sm:text-sm text-gray-700" data-id="element-206">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-207">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 flex items-center" data-id="element-208">
              <TagIcon className="h-3 w-3 mr-1 text-indigo-600" data-id="element-209" />
              Style Preference
            </label>
            <select value={userProfile.style || ''} onChange={e => handleChange('style', e.target.value)} className="w-full p-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-xs sm:text-sm" data-id="element-210">
              <option value="" data-id="element-211">Select a style</option>
              {styleOptions.map(option => <option key={option} value={option} data-id="element-212">
                  {option}
                </option>)}
            </select>
          </div>
          <div data-id="element-213">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 flex items-center" data-id="element-214">
              <RulerIcon className="h-3 w-3 mr-1 text-indigo-600" data-id="element-215" />
              Body Type
            </label>
            <select value={userProfile.bodyType || ''} onChange={e => handleChange('bodyType', e.target.value)} className="w-full p-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-xs sm:text-sm" data-id="element-216">
              <option value="" data-id="element-217">Select a body type</option>
              {bodyTypeOptions.map(option => <option key={option} value={option} data-id="element-218">
                  {option}
                </option>)}
            </select>
          </div>
          <div data-id="element-219">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 flex items-center" data-id="element-220">
              <CalendarIcon className="h-3 w-3 mr-1 text-indigo-600" data-id="element-221" />
              Age Range
            </label>
            <select value={userProfile.ageRange || ''} onChange={e => handleChange('ageRange', e.target.value)} className="w-full p-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-xs sm:text-sm" data-id="element-222">
              <option value="" data-id="element-223">Select an age range</option>
              {ageRanges.map(option => <option key={option} value={option} data-id="element-224">
                  {option}
                </option>)}
            </select>
          </div>
          <div className="sm:col-span-2" data-id="element-225">
            <div className="flex justify-end" data-id="element-226">
              <button onClick={() => setIsExpanded(false)} className="bg-indigo-600 text-white px-3 py-1 rounded-md hover:bg-indigo-700 transition text-xs sm:text-sm" data-id="element-227">
                Save Preferences
              </button>
            </div>
          </div>
        </div>}
    </div>;
}